export class ConnectorVariantModel {
    _id: string;
    variantId: string;
    name: string;
    description: string;
    system: string;
    corrosionProtection: string;

    constructor(id = '',
        variantId = '',
        name = '',
        description = '',
        system = '',
        corrosionProtection = '') {
            this._id = id;
            this.variantId = variantId;
            this.description = description;
            this.system = system;
            this.corrosionProtection = corrosionProtection;
            this.name = name;
    }
}
